import { useHealthInsuranceValues } from './HealthInsuranceContext'
import { MIN_AGE } from './utils'
import { ContractorTypeFields } from '../PersonsFields'

export const ContractorType = () => {
  const { isEditable } = useHealthInsuranceValues()

  return (
    <ContractorTypeFields
      minAge={MIN_AGE}
      isEditable={isEditable}
      showResident
    />
  )
}
